import { Directive, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';

@Directive({
  selector: '[backdropEvent]',
  standalone: true,
})
export class BackdropEventDirective {
  @Output() clickedOnBackdrop = new EventEmitter<void>();

  private elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement) {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.clickedOnBackdrop.emit();
    }
  }
}
